module.exports = __webpack_public_path__ + "img/dhg.b14d0ec2.png";